<template lang="pug">
    router-link.battles-banner(:to="link")
        video.battles-banner__video(autoplay loop muted)
            source(src="gifs/2025_olympiad.mp4" type="video/mp4")
</template>

<script>
    export default {
        computed: {
            link() {
                return {
                    name: 'olympiads:show',
                    params: {id: 27}
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
.battles-banner {
    display: block;
    overflow: hidden;
    cursor: pointer;

    border-radius: $border-radius-20;
    background-color: $x-color-white;
}
.battles-banner__gif {
    width: 100%;
    outline: 2px solid $hsl-color-gray-98;
    outline-offset: -2px;
}
.battles-banner__video {
    width: 100%;
    outline: 2px solid $hsl-color-gray-98;
    outline-offset: -2px;
}
</style>
